<template>
	<div class="banner">
		<el-carousel trigger="click" height="480px">
			<el-carousel-item v-for="(item, index) in sliderData" :key="index">
				<a v-if="item.Url && (item.Url.startsWith('http://') || item.Url.startsWith('https://'))"
					:href="item.Url" target="_blank">
					<img :src="item.FileUrl" />
				</a>
				<a v-else>
					<img :src="item.FileUrl" />
				</a>
			</el-carousel-item>
		</el-carousel>
	</div>
</template>
<script>
export default {
	name: 'slider',
	props: {
		sliderData: {
			type: Array,
			default: () => []
		}
	}
}
</script>
<style lang="less" scoped>
.banner {
	width: 100%;
	height: 480px;
	position: relative;
	z-index: 1;
	margin-top: -20px;

	/deep/.el-carousel__indicators--horizontal {
		bottom: 18px;

		.el-carousel__indicator--horizontal button {
			width: 14px;
			height: 14px;
			background-color: #0376be;
			border-radius: 50%;
			opacity: 1;
		}

		.el-carousel__indicator--horizontal.is-active button {
			width: 35px;
			height: 14px;
			background-color: #0376be;
			border-radius: 7px;
			opacity: 1;
		}
	}
}
</style>


// WEBPACK FOOTER //
// src/components/slider.vue